export const ymOptions = {
	accurateTrackBounce: true,
	clickmap: true,
	ecommerce: 'dataLayer',
	ssr: true,
	trackLinks: true,
	webvisor: true,
};
